// eslint-disable-next-line no-restricted-imports
import { FormattedMessage as FormattedMessageIntl } from 'react-intl'
import config from 'utils/config'

const ENV = config.get('ENVIRONMENT')

function FormattedMessage(props = {}) {
  if (!Object.keys(props).length) {
    switch (ENV) {
      case 'local':
      case 'dev':
      case 'test': {
        // eslint-disable-next-line no-console
        console.error('MISSING TRANSLATION KEY')
        return <span style={{ color: 'red' }}>MISSING TRANSLATION KEY</span>
      }
      case 'production':
        return ''
      case 'staging':
      default:
      // do nothing, let it crash
    }
  }

  return <FormattedMessageIntl {...props} />
}

const TFormattedMessage = null // TODO
export { FormattedMessage, TFormattedMessage }
